<script>
    import Constantes from "../../Classes/Constantes";
    import {
        ItemInserir,
        Tipo,
        generateCreateTableSQL,
    } from "../../Classes/ItemInserir";
    import { permissaoUsuario } from "../../Classes/Stores";
    import AlteraDadosBasico from "../../Componentes/AlteracaoDados/AlteraDadosBasico.svelte";
    import InserirDadosBasico from "../../Componentes/InsercaoDados/InserirDadosBasico.svelte";
    export let params;
    export let id=params;
    const itens = [
        new ItemInserir({
            rotulo: "Atletas",
            nomeColuna: "atletas",
            tamanho: 100,
            tipo: Tipo.TEXTO,
            obrigatorio: true,
            readonly:true
        }),
         new ItemInserir({
            rotulo: "Categoria",
            nomeColuna: "nome_categoria",
            tamanho: 30,
            tipo: Tipo.TEXTO,
            obrigatorio: false,
            readonly:true
        }),
         new ItemInserir({
            rotulo: "Status",
            nomeColuna: "status_pagamento",
            tamanho: 100,
            tipo: Tipo.TEXTO,
            obrigatorio: false,
            readonly:true
        }),
          new ItemInserir({
            rotulo: "Cod",
            nomeColuna: "cod_inscricao_encurtado",
            tamanho: 30,
            tipo: Tipo.TEXTO,
            obrigatorio: false,
            readonly: true
        }),
        new ItemInserir({
            rotulo: "Campeonato",
            nomeColuna: "nome_campeonato",
            tamanho: 100,
            tipo: Tipo.TEXTO,
            obrigatorio: false,
            readonly:true
        }),
        
       
    ];
</script>

{#if $permissaoUsuario && $permissaoUsuario.permissoes.includes(Constantes.pode_editar_inscricao)}
    {#if id}
        <AlteraDadosBasico
            {id}
            strong={true}
            apiConsultaEdicao={Constantes.api_consultar_padrao}
            apiEdicao = {Constantes.api_editar_padrao}
            query_code_carregar_edicao={"carrega_dados"}
            tabela={"minhas_inscricoes_view"}
            tabelaEdicao={"inscricoes_campeonatos"}
            navegar_para={Constantes.tela_inscritos}
            {itens}
            edita={false}
        />
    {:else}
        <InserirDadosBasico
            strong={true}
            api={Constantes.api_inserir_sem_query_code}
            query_code_inserir={"teste"}
            tabela={""}
            {itens}
        />
    {/if}
{/if}
